export enum VatCorrectionsStatus {
	APPROVED = 'APPROVED',
	REJECTED = 'REJECTED',
	PENDING = 'PENDING',
}

export enum VatCorrectionsScheme {
	UNION = 'UNION',
	NON_UNION = 'NON_UNION',
	IMPORT = 'IMPORT',
	NON_EU_IMPORT = 'NON_EU_IMPORT',
}

export const VAT_CORRECTIONS_SCHEMES = [
	VatCorrectionsScheme.UNION,
	VatCorrectionsScheme.NON_UNION,
	VatCorrectionsScheme.IMPORT,
	VatCorrectionsScheme.NON_EU_IMPORT,
];

export const VAT_CORRECTIONS_SCHEME_NAMES = {
	[VatCorrectionsScheme.UNION]: 'OSS',
	[VatCorrectionsScheme.NON_UNION]: 'Non-Union OSS',
	[VatCorrectionsScheme.IMPORT]: 'IOSS',
	[VatCorrectionsScheme.NON_EU_IMPORT]: 'UK Import',
};

export const VAT_CORRECTIONS_SUBMIT_UNION = 'em_vat_report_vat_corrections_union';
export const VAT_CORRECTIONS_SUBMIT_NON_UNION = 'em_vat_report_vat_corrections_non_union';
export const VAT_CORRECTIONS_SUBMIT_IMPORT = 'em_vat_report_vat_corrections_import';
export const VAT_CORRECTIONS_SUBMIT_NON_EU_IMPORT = 'em_vat_report_vat_corrections_non_eu_import';

export const VAT_CORRECTIONS_SUBMIT_TYPES = {
	[VatCorrectionsScheme.UNION]: VAT_CORRECTIONS_SUBMIT_UNION,
	[VatCorrectionsScheme.NON_UNION]: VAT_CORRECTIONS_SUBMIT_NON_UNION,
	[VatCorrectionsScheme.IMPORT]: VAT_CORRECTIONS_SUBMIT_IMPORT,
	[VatCorrectionsScheme.NON_EU_IMPORT]: VAT_CORRECTIONS_SUBMIT_NON_EU_IMPORT,
};

// ['IOSS-NON-UNION', 'Non-Union OSS'],
// ['IOSS-UNION', 'OSS'],
// ['IOSS-IMPORT', 'IOSS'],
// ['FC-', 'DDP/DDU Sales'],
// // ['FC-SIMPLE-REP', 'DDP/DDU Sales'],
// ['B2B-INTRA-COMMUNAL', 'B2B'],
// ['B2B-DOMESTIC', 'B2B Domestic'],
// ['B2C-DOMESTIC', 'B2C Domestic'],
// ['GIFTCARD_SCHEME', 'Gift Cards'],
// ['NON_EU_IMPORT', 'NON EU Import'],
// ['NON_EU_DOMESTIC', 'NON EU Domestic'],

export enum Scheme {
	IOSS_NON_UNION = 'IOSS-NON-UNION',
	IOSS_UNION = 'IOSS-UNION',
	IOSS_IMPORT = 'IOSS-IMPORT',
	FC_SIMPLE_REP = 'FC-SIMPLE-REP',
	B2B_INTRA_COMMUNAL = 'B2B-INTRA-COMMUNAL',
	B2B_DOMESTIC = 'B2B-DOMESTIC',
	B2C_DOMESTIC = 'B2C-DOMESTIC',
	GIFTCARD_SCHEME = 'GIFTCARD_SCHEME',
	NON_EU_IMPORT = 'NON_EU_IMPORT',
	NON_EU_DOMESTIC = 'NON_EU_DOMESTIC',
}

export const SCHEMES = [
	Scheme.IOSS_NON_UNION,
	Scheme.IOSS_UNION,
	Scheme.IOSS_IMPORT,
	Scheme.FC_SIMPLE_REP,
	Scheme.B2B_INTRA_COMMUNAL,
	Scheme.B2B_DOMESTIC,
	Scheme.B2C_DOMESTIC,
	Scheme.GIFTCARD_SCHEME,
	Scheme.NON_EU_IMPORT,
	Scheme.NON_EU_DOMESTIC,
];

export const SCHEME_NAMES = {
	[Scheme.IOSS_NON_UNION]: 'Non-Union OSS',
	[Scheme.IOSS_UNION]: 'OSS',
	[Scheme.IOSS_IMPORT]: 'IOSS',
	[Scheme.FC_SIMPLE_REP]: 'DDP/DDU Sales',
	[Scheme.B2B_INTRA_COMMUNAL]: 'B2B',
	[Scheme.B2B_DOMESTIC]: 'B2B Domestic',
	[Scheme.B2C_DOMESTIC]: 'B2C Domestic',
	[Scheme.GIFTCARD_SCHEME]: 'Gift Cards',
	[Scheme.NON_EU_IMPORT]: 'NON EU Import',
	[Scheme.NON_EU_DOMESTIC]: 'NON EU Domestic',
};

export const VAT_CORRECTIONS_SCHEMES_TO_SCHEMES = {
	[VatCorrectionsScheme.UNION]: Scheme.IOSS_UNION,
	[VatCorrectionsScheme.NON_UNION]: Scheme.IOSS_NON_UNION,
	[VatCorrectionsScheme.IMPORT]: Scheme.IOSS_IMPORT,
	[VatCorrectionsScheme.NON_EU_IMPORT]: Scheme.NON_EU_IMPORT,
};

export const SCHEMES_TO_VAT_CORRECTIONS_SCHEMES = {
	[Scheme.IOSS_UNION]: VatCorrectionsScheme.UNION,
	[Scheme.IOSS_NON_UNION]: VatCorrectionsScheme.NON_UNION,
	[Scheme.IOSS_IMPORT]: VatCorrectionsScheme.IMPORT,
	[Scheme.NON_EU_IMPORT]: VatCorrectionsScheme.NON_EU_IMPORT,
};

// export const DELIVERY_OPERATORS = [
// 	{
// 		code: 'ASENDIA',
// 		label: 'Asendia',
// 	},
// 	{
// 		code: 'AUSTRALIAN_POST',
// 		label: 'Australian Post',
// 	},
// 	{
// 		code: 'CANADA_POST',
// 		label: 'Canada Post',
// 	},
// 	{
// 		code: 'DHL',
// 		label: 'DHL',
// 	},
// 	{
// 		code: 'DPD',
// 		label: 'DPD',
// 	},
// 	{
// 		code: 'EVRI',
// 		label: 'Evri',
// 	},
// 	{
// 		code: 'FEDEX',
// 		label: 'FedEx',
// 	},
// 	{
// 		code: 'PARCELFORCE',
// 		label: 'ParcelForce',
// 	},
// 	{
// 		code: 'POSTNORD',
// 		label: 'PostNord',
// 	},
// 	{
// 		code: 'ROYAL_MAIL',
// 		label: 'Royal Mail',
// 	},
// 	{
// 		code: 'SWISS_POST',
// 		label: 'Swiss Post',
// 	},
// 	{
// 		code: 'UPS',
// 		label: 'UPS',
// 	},
// 	{
// 		code: 'USPS',
// 		label: 'USPS',
// 	},
// 	{
// 		code: 'YUN_EXPRESS',
// 		label: 'Yun Express',
// 	},
// 	{
// 		code: 'OTHER',
// 		label: 'Other',
// 	},
// ];

export enum DeliveryOperator {
	ASENDIA = 'ASENDIA',
	AUSTRALIAN_POST = 'AUSTRALIAN_POST',
	CANADA_POST = 'CANADA_POST',
	DHL = 'DHL',
	DPD = 'DPD',
	EVRI = 'EVRI',
	FEDEX = 'FEDEX',
	PARCELFORCE = 'PARCELFORCE',
	POSTNORD = 'POSTNORD',
	ROYAL_MAIL = 'ROYAL_MAIL',
	SWISS_POST = 'SWISS_POST',
	UPS = 'UPS',
	USPS = 'USPS',
	YUN_EXPRESS = 'YUN_EXPRESS',
	OTHER = 'OTHER',
}

export const DELIVERY_OPERATORS_NAMES = {
	[DeliveryOperator.ASENDIA]: 'Asendia',
	[DeliveryOperator.AUSTRALIAN_POST]: 'Australian Post',
	[DeliveryOperator.CANADA_POST]: 'Canada Post',
	[DeliveryOperator.DHL]: 'DHL',
	[DeliveryOperator.DPD]: 'DPD',
	[DeliveryOperator.EVRI]: 'Evri',
	[DeliveryOperator.FEDEX]: 'FedEx',
	[DeliveryOperator.PARCELFORCE]: 'ParcelForce',
	[DeliveryOperator.POSTNORD]: 'PostNord',
	[DeliveryOperator.ROYAL_MAIL]: 'Royal Mail',
	[DeliveryOperator.SWISS_POST]: 'Swiss Post',
	[DeliveryOperator.UPS]: 'UPS',
	[DeliveryOperator.USPS]: 'USPS',
	[DeliveryOperator.YUN_EXPRESS]: 'Yun Express',
	[DeliveryOperator.OTHER]: 'Other',
};

export const DELIVERY_OPERATORS = [
	DeliveryOperator.ASENDIA,
	DeliveryOperator.AUSTRALIAN_POST,
	DeliveryOperator.CANADA_POST,
	DeliveryOperator.DHL,
	DeliveryOperator.DPD,
	DeliveryOperator.EVRI,
	DeliveryOperator.FEDEX,
	DeliveryOperator.PARCELFORCE,
	DeliveryOperator.POSTNORD,
	DeliveryOperator.ROYAL_MAIL,
	DeliveryOperator.SWISS_POST,
	DeliveryOperator.UPS,
	DeliveryOperator.USPS,
	DeliveryOperator.YUN_EXPRESS,
	DeliveryOperator.OTHER,
];
